var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("nav", { staticClass: "primary-nav" }, [
    _c("div", {
      staticClass: "primary-nav__overlay",
      on: {
        click: function($event) {
          $event.preventDefault()
          return _vm.closeMenu()
        }
      }
    }),
    _vm._v(" "),
    _c("div", { staticClass: "primary-nav__viewport" }, [
      _c("div", { staticClass: "primary-nav__content" }, [
        _vm.topMenuData.length
          ? _c(
              "ul",
              { staticClass: "primary-nav__top-menu visible-xs" },
              _vm._l(_vm.topMenuData, function(post) {
                return _c("li", { key: post.ID }, [
                  _c("a", {
                    attrs: { href: post.url },
                    domProps: { innerHTML: _vm._s(post.title) },
                    on: {
                      click: function($event) {
                        $event.preventDefault()
                        return _vm.didSelectPost(post)
                      }
                    }
                  })
                ])
              }),
              0
            )
          : _vm._e(),
        _vm._v(" "),
        _c(
          "ul",
          { staticClass: "primary-nav__menu" },
          _vm._l(_vm.menuData, function(post) {
            return _c(
              "li",
              { key: post.ID },
              [
                _c("a", {
                  class: {
                    "has-children": post.children && post.children.length > 0,
                    selected: post.object_id == _vm.currentId,
                    open:
                      post.children &&
                      post.children.length &&
                      _vm.selectedPost === post
                  },
                  attrs: { href: post.url },
                  domProps: { innerHTML: _vm._s(post.title) },
                  on: {
                    click: function($event) {
                      $event.preventDefault()
                      return _vm.didSelectPost(post)
                    }
                  }
                }),
                _vm._v(" "),
                _c(
                  "transition",
                  {
                    attrs: { name: "expand" },
                    on: {
                      enter: _vm.enter,
                      "after-enter": _vm.afterEnter,
                      leave: _vm.leave
                    }
                  },
                  [
                    post.children &&
                    post.children.length &&
                    _vm.selectedPost === post
                      ? _c(
                          "ul",
                          { staticClass: "primary-nav__menu__sub-menu" },
                          [
                            _c("li", [
                              _c("a", {
                                class: {
                                  selected: post.object_id == _vm.currentId
                                },
                                attrs: { href: post.url },
                                domProps: { innerHTML: _vm._s(post.title) },
                                on: {
                                  click: function($event) {
                                    $event.preventDefault()
                                    return _vm.didSelectParentPost(post)
                                  }
                                }
                              })
                            ]),
                            _vm._v(" "),
                            _vm._l(post.children, function(childPost) {
                              return _c("li", { key: childPost.ID }, [
                                _c("a", {
                                  class: {
                                    selected:
                                      childPost.object_id == _vm.currentId
                                  },
                                  attrs: { href: childPost.url },
                                  domProps: {
                                    innerHTML: _vm._s(childPost.title)
                                  },
                                  on: {
                                    click: function($event) {
                                      $event.preventDefault()
                                      return _vm.didSelectPost(childPost)
                                    }
                                  }
                                })
                              ])
                            })
                          ],
                          2
                        )
                      : _vm._e()
                  ]
                )
              ],
              1
            )
          }),
          0
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// /home/omer/Projects/Arcadian/embl/wp-content/themes/embl/node_modules/vue-loader/lib/loaders/templateLoader.js?{}!/home/omer/Projects/Arcadian/embl/wp-content/themes/embl/node_modules/vue-loader/lib?{}!./scripts/vue/PrimaryMenu.vue?vue&type=template&id=408ac606&
// module id = 79
// module chunks = 0